import { useCartStore } from '@/store/cartStore';
import { useHeldSalesStore } from '@/store/heldSalesStore';

export function parkCartForRecovery(): boolean {
  const cart = useCartStore.getState();
  if (cart.items.length === 0) return false;
  const time = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  const label = cart.customer ? `Recovered · ${cart.customer.fullName}` : `Recovered · ${time}`;
  useHeldSalesStore.getState().hold(label, cart.items, cart.customer);
  return true;
}
